var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowUpCreatedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFF4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 12.4922V15.1922M18.15 12.4922V15.1922M22.2 12.4922V15.1922M18.6 24.1922H22.2M18.6 20.5922H25.8M23.1 13.8422H21.3C18.33 13.8422 16.845 13.8422 15.9225 14.7647C15 15.6872 15 17.1722 15 20.1422V24.1922C15 27.1622 15 28.6472 15.9225 29.5697C16.845 30.4922 18.33 30.4922 21.3 30.4922H23.1C26.07 30.4922 27.555 30.4922 28.4775 29.5697C29.4 28.6472 29.4 27.1622 29.4 24.1922V20.1422C29.4 17.1722 29.4 15.6872 28.4775 14.7647C27.555 13.8422 26.07 13.8422 23.1 13.8422Z",
    stroke: "#F79009",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6215 24.2259C27.5885 24.3029 27.5406 24.3726 27.4807 24.4311L24.424 27.414C24.3709 27.4656 24.306 27.5034 24.2349 27.5241L23.2464 27.8106C23.2268 27.8163 23.206 27.8165 23.1862 27.8113C23.1665 27.8061 23.1485 27.7956 23.1343 27.781C23.12 27.7664 23.1099 27.7482 23.1052 27.7283C23.1004 27.7085 23.1011 27.6877 23.1072 27.6682L23.4181 26.6873C23.4408 26.6166 23.4804 26.5526 23.5336 26.5009L26.59 23.518C26.6499 23.4595 26.7208 23.4134 26.7986 23.3823C26.8764 23.3512 26.9595 23.3358 27.0432 23.3368C27.127 23.3379 27.2097 23.3554 27.2867 23.3884C27.3637 23.4214 27.4334 23.4692 27.4919 23.5292C27.5504 23.5891 27.5965 23.66 27.6275 23.7378C27.6586 23.8156 27.6741 23.8987 27.6731 23.9825C27.672 24.0662 27.6545 24.1489 27.6215 24.2259Z",
    stroke: "#F79009",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpCreatedIcon);
export default __webpack_public_path__ + "static/media/FollowUp-Created-icon.d8bcce9c37866ccada45d89ec30ff642.svg";
export { ForwardRef as ReactComponent };